import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalInterface {
  id: string;
  title?: string;
  titleCenter?: boolean;
  size?: undefined | "lg" | "sm" | "xl" | "md";
  static?: boolean;
  hideHeader?: boolean;

  allowBottomSheet?: boolean;
  bottomSheetHideTitle?: boolean;

  screenMobileView?: boolean;
  webViewUrl?: string;
  //body: React.ReactNode;
}

interface ModalListInterface {
  list: ModalInterface[];
}

const initialState: ModalListInterface = {
  list: [],
};

const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    addModal: (state, action: PayloadAction<ModalInterface>) => {
      const modal: Array<ModalInterface> = state.list.filter(
        (item) => item.id === action.payload.id
      );
      if (modal.length === 0) {
        state.list.push(action.payload);
      }
    },
    removeModal: (state, action: PayloadAction<string>) => {
      state.list = state.list.filter((item) => item.id !== action.payload);
    },

    removeAllModal: (state) => {
      state.list = [];
    },
  },
});

export const { addModal, removeModal, removeAllModal } = modalsSlice.actions;

export default modalsSlice.reducer;
